import React, { useEffect, useState } from "react";
import {
  Checkbox,
  ThemeProvider,
  TextField,
  Autocomplete,
  Box,
  Button,
} from "@mui/material";
import {
  CreatableAutocompleteWrapper,
  PaperStyles,
} from "./MuiAutocomplete.style";
import { StyleWrapper } from "../mui-dropdown/MuiDropdown.style";
import ImageAssets from "../../../../assets";
import { CircularLoader } from "../../loaders/CircularLoader";

const icon = <img src={ImageAssets.ic_add_artist} alt="" />;
const checkedIcon = <img src={ImageAssets.ic_remove_artist} alt="" />;

const MuiAutocomplete = ({
  component,
  fieldValue,
  fieldId,
  value,
  handleChange,
  dropdownData,
  backgroundColor,
  borderRadius,
  maxSelectable,
  handleInputChange,
  isLoading,
  disableClearable = true,
}: any) => {
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState<any[]>([]);

  useEffect(() => {
    setOptions(dropdownData);
  }, [dropdownData]);

  const handleReset = () => {
    handleChange([]);
    setInputValue('');
  };

  return (
    <CreatableAutocompleteWrapper
      backgroundColor={backgroundColor}
      borderRadius={borderRadius}
    >
      <ThemeProvider theme={PaperStyles}>
        <Autocomplete
          multiple
          disableClearable={disableClearable}
          value={value}
          options={options}
          clearOnBlur
          // open={true}
          // loadingText=""
          // loading={isLoading}
          // disableCloseOnSelect
          // open={open}
          // open={true}
          isOptionEqualToValue={(option: any, value: any) =>
            option[fieldId] === value[fieldId]
          }
          // onOpen={() => {
          //   if (inputValue) {
          //     setOpen(true);
          //   }
          // }}
          // onClose={() => setOpen(false)}
          onChange={(event, value) => {
            handleChange(value);
          }}
          inputValue={inputValue}
          onInputChange={(e, value, reason) => {
            setInputValue(value);
            handleInputChange(value)

            // if (!value) {
            //   setOpen(false);
            // }
          }}

          filterOptions={() => options}
          onReset={handleReset}


          getOptionDisabled={(options) =>
            maxSelectable
              ? value.length >= maxSelectable
                ? true
                : false
              : false
          }

          getOptionLabel={(option: any) => option[fieldValue]}

          renderOption={(props, option, { selected, index }) => {
            return (
              <>
                {isLoading ?
                  <Box sx={{
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}>
                    <CircularLoader />
                  </Box>
                  :
                  <li
                    {...props}
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    {component ?
                      <div style={{ display: 'flex', gap: '1rem' }}>
                        <div>
                          <img src={option["profilePic"] || ImageAssets.ic_default_profile_image} style={{ width: '4rem', height: '4rem', borderRadius: '1.8rem', objectFit: 'cover' }} />
                        </div>
                        <div>
                          <p style={{ fontSize: '1.4rem' }}>{option[fieldValue]}</p>
                          <p style={{ fontSize: '1.2rem', color: 'var(--secondary-lite-grey-color' }}>{option["fullName"] || ''}</p>
                        </div>
                      </div>
                      :
                      <p>{option[fieldValue]}</p>
                    }
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      checked={selected}
                    />
                  </li >
                }
              </>
            );
          }}

          renderInput={(params: any) => (
            <TextField
              size="medium"
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {isLoading ? <CircularLoader /> : null}
                    {/* {params.InputProps.endAdornment} */}
                  </React.Fragment>
                ),
              }}
              // InputProps={{
              //   startAdornment: (
              //     <InputAdornment position="start">
              //       <img src={ImageAssets.ic_search_header} alt="" />
              //     </InputAdornment>
              //   ),
              // }}
              {...params}
              placeholder="Search"
            />
          )}
        />
      </ThemeProvider>
    </CreatableAutocompleteWrapper >
  );
};

const MultiSelectAutocomplete = ({
  menuitems,
  value,
  handleChange,
  label,
  placeholder,
  fieldId,
  fieldValue
}: any) => {
  return (
    <StyleWrapper value={value.length === 0 ? "" : value}>
      <ThemeProvider theme={PaperStyles}>
        <Autocomplete
          multiple
          disableClearable
          value={value}
          options={menuitems}
          onChange={handleChange}
          getOptionLabel={(option: any) => option[fieldValue]}
          isOptionEqualToValue={(option: any, value: any) =>
            option[fieldId] === value[fieldId]
          }
          filterSelectedOptions
          renderInput={(params) => (
            <TextField {...params} label={label} placeholder={placeholder} />
          )}
        />
      </ThemeProvider>
    </StyleWrapper>
  );
};

export { MuiAutocomplete, MultiSelectAutocomplete };
